import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthLinkController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthLinkController.php
* @route '/api/company/{company}/square-up/get-auth-link'
*/
const GetSquareUpAuthLinkController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSquareUpAuthLinkController.url(args, options),
    method: 'get',
})

GetSquareUpAuthLinkController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/square-up/get-auth-link',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthLinkController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthLinkController.php
* @route '/api/company/{company}/square-up/get-auth-link'
*/
GetSquareUpAuthLinkController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetSquareUpAuthLinkController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthLinkController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthLinkController.php
* @route '/api/company/{company}/square-up/get-auth-link'
*/
GetSquareUpAuthLinkController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSquareUpAuthLinkController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SquareUp\GetSquareUpAuthLinkController::__invoke
* @see app/Http/Controllers/SquareUp/GetSquareUpAuthLinkController.php
* @route '/api/company/{company}/square-up/get-auth-link'
*/
GetSquareUpAuthLinkController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSquareUpAuthLinkController.url(args, options),
    method: 'head',
})

export default GetSquareUpAuthLinkController